export const VIDEO_BACKENDS = [
  { id: "backend-heygen", label: "HeyGen" },
  { id: "backend-fliki", label: "Fliki" },
  { id: "backend-joggai", label: "JoggAI" },
];

export const DEFAULT_VIDEO_BACKEND = "backend-heygen";

export const providerLabel = (provider) => {
  const match = VIDEO_BACKENDS.find((item) => item.id === provider);
  return match?.label || provider || "Video provider";
};

export const statusLabel = (status) => {
  if (status === "pending") return "Queued";
  if (status === "generating") return "Generating";
  if (status === "completed") return "Ready";
  if (status === "failed") return "Failed";
  return status || "Unknown";
};

export const videoButtonLabel = (count) => {
  if (!count) return "Create video";
  return count === 1 ? "1 video" : `${count} videos`;
};
